import React, { useState } from 'react';
import styled from 'styled-components';
import CompanyInfoModal from './CompanyInfoModal';

const Footer = ({ showDisclaimer = false, style, className }) => {
  const [showCompanyInfo, setShowCompanyInfo] = useState(false);

  return (
    <FooterContainer style={style} className={className}>
      <FooterContent>
        <FooterMain>
          <FooterSection>
            <FooterSectionTitle>产品服务</FooterSectionTitle>
            <FooterLinkList>
              <FooterLink>模拟面试</FooterLink>
              <FooterLink>简历诊断</FooterLink>
              <FooterLink>面试押题</FooterLink>
            </FooterLinkList>
          </FooterSection>

          <FooterSection>
            <FooterSectionTitle>关于我们</FooterSectionTitle>
            <FooterLinkList>
              <FooterLink onClick={() => setShowCompanyInfo(true)}>公司介绍</FooterLink>
              <FooterLink>
                <FooterLinkAnchor href="/privacy">隐私协议</FooterLinkAnchor>
              </FooterLink>
              <FooterLink>
                <FooterLinkAnchor href="/terms">用户服务协议</FooterLinkAnchor>
              </FooterLink>
            </FooterLinkList>
          </FooterSection>

          <FooterSection>
            <FooterSectionTitle>联系我们</FooterSectionTitle>
            <ContactHighlight>商务合作、咨询充值、服务开通与功能答疑</ContactHighlight>
            <ContactInfo>
              <ContactLine>邮箱：contact@zhispark.com</ContactLine>
              <ContactLine>地址：浙江省杭州市萧山区德必港立WE产业园A座315室</ContactLine>
            </ContactInfo>
          </FooterSection>

          <QRCodeSection>
            <QRCodeItem>
              <picture>
                <source srcSet="/images/qrcode/kefu-qrcode.webp" type="image/webp" />
                <QRCodeImage
                  src="/images/qrcode/kefu-qrcode.png"
                  alt="联系客服二维码"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </picture>
              <QRCodeLabel>联系客服</QRCodeLabel>
            </QRCodeItem>
            <QRCodeItem>
              <picture>
                <source srcSet="/images/qrcode/wechat-qrcode.webp" type="image/webp" />
                <QRCodeImage
                  src="/images/qrcode/wechat-qrcode.png"
                  alt="微信公众号二维码"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </picture>
              <QRCodeLabel>微信公众号</QRCodeLabel>
            </QRCodeItem>
            <QRCodeItem>
              <picture>
                <source srcSet="/images/qrcode/douyin-qrcode.webp" type="image/webp" />
                <QRCodeImage
                  src="/images/qrcode/douyin-qrcode.png"
                  alt="抖音二维码"
                  onError={(e) => { e.target.style.display = 'none'; }}
                />
              </picture>
              <QRCodeLabel>抖音</QRCodeLabel>
            </QRCodeItem>
          </QRCodeSection>
        </FooterMain>

        <FooterDivider />

        <FooterBottom>
          <FooterBottomCenter>
            <CopyrightText>
              © 2026 杭州元烁智创科技有限公司 版权所有 |{' '}
              <BeianLink href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">浙ICP备2026002246号</BeianLink>{' '}
              |{' '}
              <BeianLink href="https://beian.mps.gov.cn/#/query/webSearch?code=33010902004415" target="_blank" rel="noreferrer">
                <BeianIcon src="/images/beian/beian.png" alt="公安备案" />
                浙公网安备33010902004415号
              </BeianLink>
            </CopyrightText>
          </FooterBottomCenter>
        </FooterBottom>
      </FooterContent>
      <CompanyInfoModal isOpen={showCompanyInfo} onClose={() => setShowCompanyInfo(false)} />
    </FooterContainer>
  );
};

// Styled Components
const FooterContainer = styled.footer`
  background: #1a1a1a;
  color: white;
  padding: 1.5rem 2rem 0.8rem;

  @media (max-width: 768px) {
    padding: 1.5rem 1rem 0.8rem;
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (min-width: 1920px) {
    max-width: 1500px;
    padding: 0 3rem;
  }

  @media (min-width: 2560px) {
    max-width: 1700px;
    padding: 0 4rem;
  }

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

const FooterMain = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 3.5rem;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    gap: 2.5rem;
    justify-content: space-around;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
    justify-content: flex-start;
  }
`;

const FooterSection = styled.div`
  text-align: left;
  flex: 0 0 auto;
  min-width: 140px;
  
  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
  }
`;

const FooterSectionTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.8rem;
  color: white;
  line-height: 1.4;
`;

const FooterLinkList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const FooterLink = styled.li`
  margin-bottom: 0.5rem;
  color: #9CA3AF;
  font-size: 0.85rem;
  cursor: pointer;
  transition: color 0.2s ease;
  line-height: 1.5;

  &:hover {
    color: #ffffff;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

const FooterLinkAnchor = styled.a`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: #ffffff;
  }
`;

const ContactHighlight = styled.p`
  margin: 0 0 0.6rem 0;
  font-size: 0.8rem;
  color: #34D399;
  font-weight: 500;
  line-height: 1.4;
`;

const ContactInfo = styled.div`
  margin-top: 0;
`;

const ContactLine = styled.p`
  margin: 0 0 0.5rem 0;
  font-size: 0.85rem;
  color: #9CA3AF;
  line-height: 1.5;

  &:last-child {
    margin-bottom: 0;
  }
`;

const FooterDivider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 0.8rem 0 0.6rem;
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FooterBottomCenter = styled.div`
  text-align: center;
`;

const CopyrightText = styled.p`
  color: #9CA3AF;
  font-size: 0.8rem;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    padding: 0 0.5rem;
  }
`;

const BeianLink = styled.a`
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #ffffff;
    text-decoration: underline;
  }
`;

const BeianIcon = styled.img`
  height: 16px;
  width: 16px;
  object-fit: contain;
  margin-right: 4px;
  vertical-align: text-bottom;
`;

const QRCodeSection = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  flex: 0 0 auto;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    gap: 2rem;
  }
`;

const QRCodeItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 100px;

  @media (max-width: 768px) {
    width: 90px;
  }
`;

const QRCodeImage = styled.img`
  width: 100px;
  height: 100px;
  aspect-ratio: 1 / 1;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  /* 优化样式：白边、圆角、阴影 */
  background-color: #ffffff;
  padding: 5px;
  border-radius: 8px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 768px) {
    width: 90px;
    height: 90px;
    padding: 4px;
  }
`;

const QRCodeLabel = styled.span`
  color: #9CA3AF;
  font-size: 0.75rem;
  text-align: center;
  white-space: nowrap;
`;

export default Footer;
